module.exports = __webpack_public_path__ + "static/media/about-us-splitter-2.06010405.svg";